import { Content } from "antd/es/layout/layout";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  allcountrycode,
  countrycode,
  updatenotificationdata,
} from "../../../store/Admin/Common/CommonSlice";
import { Collapse, Spin } from 'antd'
import { SpinContainer } from '../../../StyledComponents/Queries'
import {
  ButtonSection,
  ContentRow,
  ContentTitle,
  ContentValue,
  DetailContentContainer,
  FormikForm,
  FormItem,
} from "../../../StyledComponents/CreateKeyAccountManager";
import { setOrganizationCreated } from "../../../store/Organization/organizationSlice";
import {
  organizationlist,
  userorgupdate,
} from "../../../store/Organization/organizationSlice";
import AddButton from "../Common/AddButton";
import SubmitButton from "../Common/SubmitButton";
import * as Yup from "yup";
import { ErrorMessage } from "formik";
import { Input } from "antd";
import { PhoneInput } from "../Common/PhoneInput";
import { TextInputItem } from "../../../StyledComponents/Common";
import { update_kam } from "../../../store/Admin/KAM/KAMSlice";
import { all } from "axios";

const options = [
  { id: 1, value: "option1", label: "Option 1" },
  { id: 2, value: "option2", label: "Option 2" },
  { id: 3, value: "option3", label: "Option 3" },
  { id: 4, value: "option4", label: "Option 4" },
];

function ProfileSectionAdmin(props) {
  const dispatch = useDispatch();
  const [spinner, setSpinner] = useState(false);
   const [spinner1, loadSpinner] = useState(false);
  const [orgdata, setOrgdata] = useState([]);
  // const[orgregister,setOrgregister]=useState(false)
  const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  console.log(orgdata, props, "props");
  const filterval = orgdata?.filter((item) => item?._id === selectedValue);
  //    console.log(filterval[0].org_name,"filterval")
  const handleSave = () => {
    console.log("Selected value:", selectedValue);
    let payload = {
      user_id: props?.instance?._id,
      org_id: selectedValue,
    };
    setSpinner(true);

    console.log(payload, "payload");

    dispatch(userorgupdate(payload))
      .then((res) => {
        console.log("login res 1234 ", res?.payload);
        updatenotificationdata(res?.payload);
        if(res?.payload?.data?.statusCode === 200 ){
          setSpinner(false);
        }
        props.setPageType("table");
      })
      .catch((err) => {
        console.error(err);
      });
    setOpen(false);
  };

  console.log(props, orgdata, "props345");
  useEffect(() => {
    dispatch(countrycode());
  }, []);

  useEffect(() => {
    dispatch(organizationlist("all"))
      .then((res) => {
        console.log("login res => ", res);
        // if(res?.payload?.data?.statusCode === 200 ){
        setOrgdata(res?.payload?.data);

        // }
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  useEffect(() => {
    if (props.is_edit === false) {
      setSpinner(false);
    }
  }, [props.is_edit]);
  // console.log(orgdata,"props")
  const getAllCountryCode = useSelector(allcountrycode);
  const handleCreateOrganization = () => {
    dispatch(setOrganizationCreated(true)); // Set the state to true
    console.log("Organization created state updated");
  };
  const handleManageOrganization = () => {
    setOpen(true);
    console.log("Manage Organization clicked");
  };
  const handleSelectChange = (e, setFieldValue, name) => {
    setFieldValue([name], e);
  };

  const handleArchive = () => {
    console.log("archive");
  };
  const handleCancel = (resetForm) => {
    props.handleCancel();
    resetForm();
  };
  const initialValues = {
    full_name: props.instance?.full_name,
    phone_number: props.instance?.phone_number,
    email: props.instance?.email,
    whatsapp_number: props.instance?.whatsapp,
    country_code: String(props.instance?.country_code),
    wcountrycode: String(props.instance?.wcountrycode),
    id: props.instance?.id,
    company_name: props.instance?.company_name,
    keyaccount_manager: props.instance?.kam_user?.full_name,
  };
  const validationSchema = Yup.object().shape({
    full_name: Yup.string().required("Full Name is required"),
    phone_number: Yup.number()
      .typeError("Phone number must be a number")
      .test("len", "Phone number must be exactly 10 digits", (val) => {
        if (val) {
          return val.toString().length === 10;
        }
        return false;
      })
      .required("Phone number is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    whatsapp_number: Yup.number()
      .typeError("Whatsapp number must be a number")
      .test("len", "Whatsapp number must be exactly 10 digits", (val) => {
        if (val) {
          return val.toString().length === 10;
        }
        return false;
      })
      .required("Whatsapp number is required"),
  });
  console.log(orgdata, props.instance._id, "orgregister");
  //    const isMatch = orgdata.map(user => user._id === props.instance._id);
  // const isMatch = orgdata?.map(org =>
  //     org?.user_details?.some(innerUser => innerUser?._id === props?.instance?._id)
  //   );
  //   const hasMatch = isMatch?.some(match => match === true);
  //    console.log(isMatch,"isMatch")
  //    console.log(hasMatch,"hasMatch")
  // let hasMatch = false; // Default to false
  // for (let i = 0; i < orgdata?.length; i++) {
  //   const org = orgdata[i];
  //   if (org?.user_details) {
  //     for (let j = 0; j < org.user_details.length; j++) {
  //       const innerUser = org.user_details[j];
  //       if (innerUser?._id === props?.instance?._id) {
  //         hasMatch = true; // Set to true if a match is found
  //         break; // Exit the inner loop
  //       }
  //     }
  //     if (hasMatch) break; // Exit the outer loop if a match is found
  //   }
  // }
  // console.log(hasMatch);
  // `hasMatch` will be `true` if a match is found, otherwise `false`.
  let pid = props?.instance?._id;
  let odata = orgdata;
  let buttonvisible = false;
  console.log(orgdata, props.instance, "orgdata");
  for (let item of odata) {
    const ud = item?.user_details;
    for (let data of ud) {
      if (data?._id == pid) {
        buttonvisible = true;
        break;
      }
    }
  }
  console.log(buttonvisible, "d");
  console.log(props.instance, orgdata, "props.instance");
  return (
    <>
    {/* <SpinContainer>
                <Spin />
            </SpinContainer> */}
      <FormikForm
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, { resetForm }) => {
          console.log(values, "values");
          setSpinner(true);
          dispatch(update_kam(values))
            .then((res) => {
              // console.log('login res => ',res);
              dispatch(updatenotificationdata(res?.payload?.data));
              setSpinner(false);
              if (res?.payload?.status === 200) {
                resetForm();
                props.setPageType("table");
              }
            })
            .catch((err) => {
              console.error(err);
            });
        }}
      > 
        {({ values, setFieldValue, handleChange, handleBlur, resetForm }) => (
           buttonvisible===false ? (
            // <SpinContainer>
            //   <Spin />
            // </SpinContainer>
            <FormItem className="no-margin">
            <DetailContentContainer>
              <ContentRow>
                <ContentTitle>User Name</ContentTitle>
                {props.is_edit ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <TextInputItem
                      id="full_name"
                      name="full_name"
                      value={values?.full_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      size="large"
                      placeholder="Full Name"
                    />
                    <ErrorMessage
                      name="full_name"
                      component="div"
                      style={{ color: "red", fontSize: "12px" }}
                    />
                  </div>
                ) : (
                  <ContentValue>{props.instance?.full_name}</ContentValue>
                )}
              </ContentRow>
              <ContentRow>
                <ContentTitle>Email</ContentTitle>
                {props.is_edit ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <TextInputItem
                      id="email"
                      name="email"
                      type="email"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      size="large"
                      placeholder="Email"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      style={{ color: "red", fontSize: "12px" }}
                    />
                  </div>
                ) : (
                  <ContentValue>{props.instance?.email}</ContentValue>
                )}
              </ContentRow>
              <ContentRow>
                <ContentTitle>Phone Number</ContentTitle>
                {props.is_edit ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <PhoneInput
                      getAllCountryCode={getAllCountryCode}
                      name="phone_number"
                      id="phone_number"
                      value={values.phone_number}
                      handleSelectChange={handleSelectChange}
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      placeholder="Mobile Number"
                      code_name="country_code"
                      code_value={values.country_code}
                    />
                    <ErrorMessage
                      name="phone_number"
                      component="div"
                      style={{ color: "red", fontSize: "12px" }}
                    />
                  </div>
                ) : (
                  <ContentValue>
                    {props.instance?.country_code ? "+" : null}
                    {props.instance?.country_code}{" "}
                    {props.instance?.phone_number}
                  </ContentValue>
                )}
              </ContentRow>
              <ContentRow>
                <ContentTitle>Whatsapp Number</ContentTitle>

                {props.is_edit ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <PhoneInput
                      getAllCountryCode={getAllCountryCode}
                      name="whatsapp_number"
                      id="whatsapp_number"
                      value={values.whatsapp_number}
                      handleSelectChange={handleSelectChange}
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      placeholder="Whatsapp Number"
                      code_name="wcountrycode"
                      code_value={values.wcountrycode}
                    />
                    <ErrorMessage
                      name="whatsapp_number"
                      component="div"
                      style={{ color: "red", fontSize: "12px" }}
                    />
                  </div>
                ) : (
                  <ContentValue>
                    {props.instance?.wcountrycode ? "+" : null}
                    {props.instance?.wcountrycode} {props.instance?.whatsapp}
                  </ContentValue>
                )}
              </ContentRow>
              <ContentRow>
                <ContentTitle>Organization Name</ContentTitle>
                {props.is_edit ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <TextInputItem
                      id="company_name"
                      name="company_name"
                      type="company_name"
                    // 
                      value={values.company_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      size="large"
                      placeholder="Company Name"
                    />
                    <ErrorMessage
                      name="company_name"
                      component="div"
                      style={{ color: "red", fontSize: "12px" }}
                    />
                  </div>
                ) : (
                  <ContentValue>
                    {
                      <div className="flex items-center">
                        <div  className={buttonvisible===true&&("text-green-600")}>
                          {filterval[0]?.org_name
                            ? filterval[0]?.org_name
                            : props?.instance?.company_name}
                        </div>{" "}
                        <div className="flex justify-end items-center pt-2">
                          {buttonvisible===false&&(<button
                            type="button"
                            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-md text-xs px-4 py-1 me-2 mb-2 ml-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                            onClick={handleCreateOrganization}
                          >
                            Create Organization
                          </button>)}
                          <button
                            type="button"
                            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-md text-xs px-4 py-1 me-2 mb-2 ml-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                            onClick={handleManageOrganization}
                          >
                            Manage Organization
                          </button>
                        </div>
                        <div>
                          {open && (
                            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                              <div className="bg-white rounded-md shadow-lg w-96 p-6">
                                {/* Modal Header */}
                                <div className="text-lg font-bold mb-4">
                                  Select an Option
                                </div>

                                {/* Dropdown */}
                                <div className="mb-6">
                                  <select
                                    value={selectedValue}
                                    onChange={(e) =>
                                      setSelectedValue(e.target.value)
                                    }
                                    className="w-full px-4 py-2 border rounded-md bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                  >
                                    <option value="" disabled>
                                      Select an option
                                    </option>
                                    {orgdata.map((option) => (
                                      <option
                                        key={option._id}
                                        value={option._id}
                                      >
                                        {option.org_name}
                                      </option>
                                    ))}
                                  </select>
                                </div>

                                {/* Modal Footer */}
                                <div className="flex justify-end space-x-2">
                                  <button
                                    onClick={() => setOpen(false)}
                                    className="px-4 py-2 bg-gray-200 rounded-md border border-gray-300 hover:bg-gray-300"
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    onClick={handleSave}
                                    className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                                  >
                                    Save
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    }{" "}
                    {/* {buttonvisible===false && ( */}
                    {}
                    {/* )} */}
                  </ContentValue>
                )}
              </ContentRow>
              <ContentRow>
                <ContentTitle>Key Account Manager</ContentTitle>
                {props.is_edit ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <TextInputItem
                      id="keyaccount_manager"
                      name="keyaccount_manager"
                      type="keyaccount_manager"
                      value={values?.keyaccount_manager}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      size="large"
                      placeholder="Key Account Manager"
                    />
                    <ErrorMessage
                      name="keyaccount_manager"
                      component="div"
                      style={{ color: "red", fontSize: "12px" }}
                    />
                  </div>
                ) : (
                  <ContentValue>
                    {props.instance?.kam_user?.full_name}
                  </ContentValue>
                )}
              </ContentRow>
              {/* <ContentRow>
                    <ContentTitle>
                    Registration Mode 
                    </ContentTitle>
                    {props.is_edit ?
                        <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                            <TextInputItem
                                id="registration_mode"
                                name="registration_mode"
                                type='registration_mode'
                                value={values.registration_mode}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                size="large"
                                placeholder='Registraion Mode'
                            />
                            <ErrorMessage name="registration_mode" component="div" style={{ color: 'red',fontSize: '12px' }} />
                        </div> 
                    :
                        <ContentValue>
                            {props.instance?.keyaccount_manager}
                        </ContentValue>
                    }
                    
                </ContentRow> */}
            </DetailContentContainer>
            <ButtonSection>
              {props.is_edit ? (
                <>
                  {/* <AddButton title="Move To Archive" icon_type="archive" handleClick={handleArchive}  /> */}
                  <SubmitButton
                    type="button"
                    handleClick={() => handleCancel(resetForm)}
                    title="Cancel"
                    ml="28px"
                    is_icon={false}
                  />
                  <SubmitButton
                    type="submit"
                    title="save"
                    is_save={true}
                    ml="28px"
                    loading={spinner}
                  />
                </>
              ) : null}
            </ButtonSection>
          </FormItem>
          ) : (
            <FormItem className="no-margin">
            <DetailContentContainer>
              <ContentRow>
                <ContentTitle>User Name</ContentTitle>
                {props.is_edit ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <TextInputItem
                      id="full_name"
                      name="full_name"
                      value={values?.full_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      size="large"
                      placeholder="Full Name"
                    />
                    <ErrorMessage
                      name="full_name"
                      component="div"
                      style={{ color: "red", fontSize: "12px" }}
                    />
                  </div>
                ) : (
                  <ContentValue>{props.instance?.full_name}</ContentValue>
                )}
              </ContentRow>
              <ContentRow>
                <ContentTitle>Email</ContentTitle>
                {props.is_edit ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <TextInputItem
                      id="email"
                      name="email"
                      type="email"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      size="large"
                      placeholder="Email"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      style={{ color: "red", fontSize: "12px" }}
                    />
                  </div>
                ) : (
                  <ContentValue>{props.instance?.email}</ContentValue>
                )}
              </ContentRow>
              <ContentRow>
                <ContentTitle>Phone Number</ContentTitle>
                {props.is_edit ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <PhoneInput
                      getAllCountryCode={getAllCountryCode}
                      name="phone_number"
                      id="phone_number"
                      value={values.phone_number}
                      handleSelectChange={handleSelectChange}
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      placeholder="Mobile Number"
                      code_name="country_code"
                      code_value={values.country_code}
                    />
                    <ErrorMessage
                      name="phone_number"
                      component="div"
                      style={{ color: "red", fontSize: "12px" }}
                    />
                  </div>
                ) : (
                  <ContentValue>
                    {props.instance?.country_code ? "+" : null}
                    {props.instance?.country_code}{" "}
                    {props.instance?.phone_number}
                  </ContentValue>
                )}
              </ContentRow>
              <ContentRow>
                <ContentTitle>Whatsapp Number</ContentTitle>

                {props.is_edit ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <PhoneInput
                      getAllCountryCode={getAllCountryCode}
                      name="whatsapp_number"
                      id="whatsapp_number"
                      value={values.whatsapp_number}
                      handleSelectChange={handleSelectChange}
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      placeholder="Whatsapp Number"
                      code_name="wcountrycode"
                      code_value={values.wcountrycode}
                    />
                    <ErrorMessage
                      name="whatsapp_number"
                      component="div"
                      style={{ color: "red", fontSize: "12px" }}
                    />
                  </div>
                ) : (
                  <ContentValue>
                    {props.instance?.wcountrycode ? "+" : null}
                    {props.instance?.wcountrycode} {props.instance?.whatsapp}
                  </ContentValue>
                )}
              </ContentRow>
              <ContentRow>
                <ContentTitle>Organization Name</ContentTitle>
                {props.is_edit ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <TextInputItem
                      id="company_name"
                      name="company_name"
                      type="company_name"
                    // 
                      value={values.company_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      size="large"
                      placeholder="Company Name"
                    />
                    <ErrorMessage
                      name="company_name"
                      component="div"
                      style={{ color: "red", fontSize: "12px" }}
                    />
                  </div>
                ) : (
                  <ContentValue>
                    {
                      <div className="flex items-center">
                        <div  className={buttonvisible===true&&("text-green-600")}>
                          {filterval[0]?.org_name
                            ? filterval[0]?.org_name
                            : props?.instance?.company_name}
                        </div>{" "}
                        <div className="flex justify-end items-center pt-2">
                          {buttonvisible===false&&(<button
                            type="button"
                            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-md text-xs px-4 py-1 me-2 mb-2 ml-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                            onClick={handleCreateOrganization}
                          >
                            Create Organization
                          </button>)}
                          <button
                            type="button"
                            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-md text-xs px-4 py-1 me-2 mb-2 ml-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                            onClick={handleManageOrganization}
                          >
                            Manage Organization
                          </button>
                        </div>
                        <div>
                          {open && (
                            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                              <div className="bg-white rounded-md shadow-lg w-96 p-6">
                                {/* Modal Header */}
                                <div className="text-lg font-bold mb-4">
                                  Select an Option
                                </div>

                                {/* Dropdown */}
                                <div className="mb-6">
                                  <select
                                    value={selectedValue}
                                    onChange={(e) =>
                                      setSelectedValue(e.target.value)
                                    }
                                    className="w-full px-4 py-2 border rounded-md bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                  >
                                    <option value="" disabled>
                                      Select an option
                                    </option>
                                    {orgdata.map((option) => (
                                      <option
                                        key={option._id}
                                        value={option._id}
                                      >
                                        {option.org_name}
                                      </option>
                                    ))}
                                  </select>
                                </div>

                                {/* Modal Footer */}
                                <div className="flex justify-end space-x-2">
                                  <button
                                    onClick={() => setOpen(false)}
                                    className="px-4 py-2 bg-gray-200 rounded-md border border-gray-300 hover:bg-gray-300"
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    onClick={handleSave}
                                    className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                                  >
                                    Save
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    }{" "}
                    {/* {buttonvisible===false && ( */}
                    {}
                    {/* )} */}
                  </ContentValue>
                )}
              </ContentRow>
              <ContentRow>
                <ContentTitle>Key Account Manager</ContentTitle>
                {props.is_edit ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <TextInputItem
                      id="keyaccount_manager"
                      name="keyaccount_manager"
                      type="keyaccount_manager"
                      value={values?.keyaccount_manager}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      size="large"
                      placeholder="Key Account Manager"
                    />
                    <ErrorMessage
                      name="keyaccount_manager"
                      component="div"
                      style={{ color: "red", fontSize: "12px" }}
                    />
                  </div>
                ) : (
                  <ContentValue>
                    {props.instance?.kam_user?.full_name}
                  </ContentValue>
                )}
              </ContentRow>
              {/* <ContentRow>
                    <ContentTitle>
                    Registration Mode 
                    </ContentTitle>
                    {props.is_edit ?
                        <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                            <TextInputItem
                                id="registration_mode"
                                name="registration_mode"
                                type='registration_mode'
                                value={values.registration_mode}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                size="large"
                                placeholder='Registraion Mode'
                            />
                            <ErrorMessage name="registration_mode" component="div" style={{ color: 'red',fontSize: '12px' }} />
                        </div> 
                    :
                        <ContentValue>
                            {props.instance?.keyaccount_manager}
                        </ContentValue>
                    }
                    
                </ContentRow> */}
            </DetailContentContainer>
            <ButtonSection>
              {props.is_edit ? (
                <>
                  {/* <AddButton title="Move To Archive" icon_type="archive" handleClick={handleArchive}  /> */}
                  <SubmitButton
                    type="button"
                    handleClick={() => handleCancel(resetForm)}
                    title="Cancel"
                    ml="28px"
                    is_icon={false}
                  />
                  <SubmitButton
                    type="submit"
                    title="save"
                    is_save={true}
                    ml="28px"
                    loading={spinner}
                  />
                </>
              ) : null}
            </ButtonSection>
          </FormItem>
          )
          // <FormItem className="no-margin">
          //   <DetailContentContainer>
          //     <ContentRow>
          //       <ContentTitle>User Name</ContentTitle>
          //       {props.is_edit ? (
          //         <div
          //           style={{
          //             display: "flex",
          //             flexDirection: "column",
          //             width: "50%",
          //           }}
          //         >
          //           <TextInputItem
          //             id="full_name"
          //             name="full_name"
          //             value={values?.full_name}
          //             onChange={handleChange}
          //             onBlur={handleBlur}
          //             size="large"
          //             placeholder="Full Name"
          //           />
          //           <ErrorMessage
          //             name="full_name"
          //             component="div"
          //             style={{ color: "red", fontSize: "12px" }}
          //           />
          //         </div>
          //       ) : (
          //         <ContentValue>{props.instance?.full_name}</ContentValue>
          //       )}
          //     </ContentRow>
          //     <ContentRow>
          //       <ContentTitle>Email</ContentTitle>
          //       {props.is_edit ? (
          //         <div
          //           style={{
          //             display: "flex",
          //             flexDirection: "column",
          //             width: "50%",
          //           }}
          //         >
          //           <TextInputItem
          //             id="email"
          //             name="email"
          //             type="email"
          //             value={values.email}
          //             onChange={handleChange}
          //             onBlur={handleBlur}
          //             size="large"
          //             placeholder="Email"
          //           />
          //           <ErrorMessage
          //             name="email"
          //             component="div"
          //             style={{ color: "red", fontSize: "12px" }}
          //           />
          //         </div>
          //       ) : (
          //         <ContentValue>{props.instance?.email}</ContentValue>
          //       )}
          //     </ContentRow>
          //     <ContentRow>
          //       <ContentTitle>Phone Number</ContentTitle>
          //       {props.is_edit ? (
          //         <div
          //           style={{
          //             display: "flex",
          //             flexDirection: "column",
          //             width: "50%",
          //           }}
          //         >
          //           <PhoneInput
          //             getAllCountryCode={getAllCountryCode}
          //             name="phone_number"
          //             id="phone_number"
          //             value={values.phone_number}
          //             handleSelectChange={handleSelectChange}
          //             setFieldValue={setFieldValue}
          //             handleChange={handleChange}
          //             handleBlur={handleBlur}
          //             placeholder="Mobile Number"
          //             code_name="country_code"
          //             code_value={values.country_code}
          //           />
          //           <ErrorMessage
          //             name="phone_number"
          //             component="div"
          //             style={{ color: "red", fontSize: "12px" }}
          //           />
          //         </div>
          //       ) : (
          //         <ContentValue>
          //           {props.instance?.country_code ? "+" : null}
          //           {props.instance?.country_code}{" "}
          //           {props.instance?.phone_number}
          //         </ContentValue>
          //       )}
          //     </ContentRow>
          //     <ContentRow>
          //       <ContentTitle>Whatsapp Number</ContentTitle>

          //       {props.is_edit ? (
          //         <div
          //           style={{
          //             display: "flex",
          //             flexDirection: "column",
          //             width: "50%",
          //           }}
          //         >
          //           <PhoneInput
          //             getAllCountryCode={getAllCountryCode}
          //             name="whatsapp_number"
          //             id="whatsapp_number"
          //             value={values.whatsapp_number}
          //             handleSelectChange={handleSelectChange}
          //             setFieldValue={setFieldValue}
          //             handleChange={handleChange}
          //             handleBlur={handleBlur}
          //             placeholder="Whatsapp Number"
          //             code_name="wcountrycode"
          //             code_value={values.wcountrycode}
          //           />
          //           <ErrorMessage
          //             name="whatsapp_number"
          //             component="div"
          //             style={{ color: "red", fontSize: "12px" }}
          //           />
          //         </div>
          //       ) : (
          //         <ContentValue>
          //           {props.instance?.wcountrycode ? "+" : null}
          //           {props.instance?.wcountrycode} {props.instance?.whatsapp}
          //         </ContentValue>
          //       )}
          //     </ContentRow>
          //     <ContentRow>
          //       <ContentTitle>Company Name1</ContentTitle>
          //       {props.is_edit ? (
          //         <div
          //           style={{
          //             display: "flex",
          //             flexDirection: "column",
          //             width: "50%",
          //           }}
          //         >
          //           <TextInputItem
          //             id="company_name"
          //             name="company_name"
          //             type="company_name"
          //           // 
          //             value={values.company_name}
          //             onChange={handleChange}
          //             onBlur={handleBlur}
          //             size="large"
          //             placeholder="Company Name"
          //           />
          //           <ErrorMessage
          //             name="company_name"
          //             component="div"
          //             style={{ color: "red", fontSize: "12px" }}
          //           />
          //         </div>
          //       ) : (
          //         <ContentValue>
          //           {
          //             <div className="flex items-center">
          //               <div  className={buttonvisible===true&&("text-green-600")}>
          //                 {filterval[0]?.org_name
          //                   ? filterval[0]?.org_name
          //                   : props?.instance?.company_name}
          //               </div>{" "}
          //               <div className="flex justify-end items-center pt-2">
          //                 {buttonvisible===false&&(<button
          //                   type="button"
          //                   className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-md text-xs px-4 py-1 me-2 mb-2 ml-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
          //                   onClick={handleCreateOrganization}
          //                 >
          //                   Create Organization
          //                 </button>)}
          //                 <button
          //                   type="button"
          //                   className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-md text-xs px-4 py-1 me-2 mb-2 ml-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
          //                   onClick={handleManageOrganization}
          //                 >
          //                   Manage Organization
          //                 </button>
          //               </div>
          //               <div>
          //                 {open && (
          //                   <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          //                     <div className="bg-white rounded-md shadow-lg w-96 p-6">
          //                       {/* Modal Header */}
          //                       <div className="text-lg font-bold mb-4">
          //                         Select an Option
          //                       </div>

          //                       {/* Dropdown */}
          //                       <div className="mb-6">
          //                         <select
          //                           value={selectedValue}
          //                           onChange={(e) =>
          //                             setSelectedValue(e.target.value)
          //                           }
          //                           className="w-full px-4 py-2 border rounded-md bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
          //                         >
          //                           <option value="" disabled>
          //                             Select an option
          //                           </option>
          //                           {orgdata.map((option) => (
          //                             <option
          //                               key={option._id}
          //                               value={option._id}
          //                             >
          //                               {option.org_name}
          //                             </option>
          //                           ))}
          //                         </select>
          //                       </div>

          //                       {/* Modal Footer */}
          //                       <div className="flex justify-end space-x-2">
          //                         <button
          //                           onClick={() => setOpen(false)}
          //                           className="px-4 py-2 bg-gray-200 rounded-md border border-gray-300 hover:bg-gray-300"
          //                         >
          //                           Cancel
          //                         </button>
          //                         <button
          //                           onClick={handleSave}
          //                           className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
          //                         >
          //                           Save
          //                         </button>
          //                       </div>
          //                     </div>
          //                   </div>
          //                 )}
          //               </div>
          //             </div>
          //           }{" "}
          //           {/* {buttonvisible===false && ( */}
          //           {}
          //           {/* )} */}
          //         </ContentValue>
          //       )}
          //     </ContentRow>
          //     <ContentRow>
          //       <ContentTitle>Key Account Manager</ContentTitle>
          //       {props.is_edit ? (
          //         <div
          //           style={{
          //             display: "flex",
          //             flexDirection: "column",
          //             width: "50%",
          //           }}
          //         >
          //           <TextInputItem
          //             id="keyaccount_manager"
          //             name="keyaccount_manager"
          //             type="keyaccount_manager"
          //             value={values?.keyaccount_manager}
          //             onChange={handleChange}
          //             onBlur={handleBlur}
          //             size="large"
          //             placeholder="Key Account Manager"
          //           />
          //           <ErrorMessage
          //             name="keyaccount_manager"
          //             component="div"
          //             style={{ color: "red", fontSize: "12px" }}
          //           />
          //         </div>
          //       ) : (
          //         <ContentValue>
          //           {props.instance?.kam_user?.full_name}
          //         </ContentValue>
          //       )}
          //     </ContentRow>
          //     {/* <ContentRow>
          //           <ContentTitle>
          //           Registration Mode 
          //           </ContentTitle>
          //           {props.is_edit ?
          //               <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
          //                   <TextInputItem
          //                       id="registration_mode"
          //                       name="registration_mode"
          //                       type='registration_mode'
          //                       value={values.registration_mode}
          //                       onChange={handleChange}
          //                       onBlur={handleBlur}
          //                       size="large"
          //                       placeholder='Registraion Mode'
          //                   />
          //                   <ErrorMessage name="registration_mode" component="div" style={{ color: 'red',fontSize: '12px' }} />
          //               </div> 
          //           :
          //               <ContentValue>
          //                   {props.instance?.keyaccount_manager}
          //               </ContentValue>
          //           }
                    
          //       </ContentRow> */}
          //   </DetailContentContainer>
          //   <ButtonSection>
          //     {props.is_edit ? (
          //       <>
          //         {/* <AddButton title="Move To Archive" icon_type="archive" handleClick={handleArchive}  /> */}
          //         <SubmitButton
          //           type="button"
          //           handleClick={() => handleCancel(resetForm)}
          //           title="Cancel"
          //           ml="28px"
          //           is_icon={false}
          //         />
          //         <SubmitButton
          //           type="submit"
          //           title="save"
          //           is_save={true}
          //           ml="28px"
          //           loading={spinner}
          //         />
          //       </>
          //     ) : null}
          //   </ButtonSection>
          // </FormItem>
        )}
      </FormikForm>
    </>
  );
}

export default ProfileSectionAdmin;
